module.exports = __webpack_public_path__ + "img/poland_flag.0be70dee.svg";